export const usersColumns = ({
  selectedIds,
  handleSelect,
  handleSelectAll,
  totalRows,
}) => [
  {
    id: "select",
    label: (
      <input
        type="checkbox"
        checked={
          totalRows > 0 &&
          selectedIds.length === totalRows
        }
        onChange={handleSelectAll}
      />
    ),
    render: (row) => (
      <input
        type="checkbox"
        checked={selectedIds.includes(row.id)}
        onChange={() => handleSelect(row.id)}
        onClick={(e) => e.stopPropagation()}
      />
    ),
  },

  {
    id: "user",
    label: "User",

    render: (row) => {
      const initials = row.name
        ?.split(" ")
        .map((n) => n[0])
        .join("")
        .slice(0, 2)
        .toUpperCase();

      const avatarColors = [
        { bg: "#EDE9FE", color: "#7C3AED" },
        { bg: "#DBEAFE", color: "#2563EB" },
        { bg: "#DCFCE7", color: "#16A34A" },
        { bg: "#FDE68A", color: "#D97706" },
        { bg: "#FCE7F3", color: "#DB2777" },
      ];

      const color =
        avatarColors[row.id % avatarColors.length];

      return (
        <div className="contact-cell">
          <div
            className="contact-avatar"
            style={{
              background: color.bg,
              color: color.color,
            }}
          >
            {initials}
          </div>

          <div className="contact-info">
            <div className="contact-name">
              {row.name}
            </div>

            <div className="contact-email">
              {row.email}
            </div>
          </div>
        </div>
      );
    },

    exportValue: (row) => row.name || "",
  },

  {
    id: "role",
    label: "Role",

    render: (row) => (
      <span className="capitalize">
        {row.role || "—"}
      </span>
    ),

    exportValue: (row) => row.role || "",
  },

  {
    id: "assigned leads",
    label: "Assigned Leads",

    render: (row) => (
      <span className="capitalize">
        {row.Leads || "0"}
      </span>
    ),

    exportValue: (row) => row.Leads || 0,
  },

  {
    id: "assigned deals",
    label: "Assigned DEALS",

    render: (row) => (
      <span className="capitalize">
        {row.assigned_deals || "0"}
      </span>
    ),

    exportValue: (row) => row.assigned_deals || 0,
  },

  {
    id: "created",
    label: "Created Date",

    render: (row) =>
      row.created_at
        ? new Date(row.created_at).toLocaleDateString()
        : "—",

    exportValue: (row) => row.created_at,
  },
];